export type CookieConsentPreference = 'allow' | 'deny';

const cookiePreferenceKey = 'nnet-cookie-preference';

export const getStoredCookiePreference = (): CookieConsentPreference | null =>
  localStorage.getItem(cookiePreferenceKey) as CookieConsentPreference | null;

export const storeCookiePreference = (preference: CookieConsentPreference) =>
  localStorage.setItem(cookiePreferenceKey, preference);
